module.exports = "/images/sala_viajero_z05.jpg?ef4cf128f5eca4accc5f6c36ee722c1f";